export default {
  baseURL      : process.env.REACT_APP_API_ROOT,
  responseType : 'json'
};
